import React, { useState, useEffect } from "react";
import CheckIcon from '@mui/icons-material/CheckCircle';
 
import { useStyles } from "./styles";

export default function useCopyLinkButton (props) {
    const {
        inProgress,
        copyLabel = 'Copy',
        copiedLabel = 'Copied',
    } = props;

    const classes = useStyles();

    const getCopyButtonLabel = () => {
        return (
            <React.Fragment>
                { copyLabel }
            </React.Fragment>
        );
    }

    const getCopiedButtonLabel = () => {
        return (
            <React.Fragment>
                <CheckIcon
                    className={classes.copiedIcon}
                />
                &nbsp;
                { copiedLabel }
            </React.Fragment>
        );
    }

    const [buttonLabel, setButtonLabel] = useState(getCopyButtonLabel());

    useEffect(() => {
        if (inProgress) {
            setButtonLabel(getCopiedButtonLabel());
        } else {
            setButtonLabel(getCopyButtonLabel());
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inProgress]);

    return {
        buttonLabel,
    };
}